import React, {Component} from 'react';
import './error.css';

import getUserProperty from './../../utils/userProfile';
import {getMessage} from './../../utils/i18n';

class Error extends Component {

    static defaultProps = {
        errorStatus: '404'
    };

    render() {
        const {errorStatus} = this.props;
        let pageType = (errorStatus === '404') ? 'pageNotFound' : 'appError';
        let userName = getUserProperty('userName') || getMessage('error.page.default-name');
        return (
            <div className="boErrorPageContainer">
                <div className="boErrorPageContent">
                    <div
                        className="boErrorPageTitle">{ getMessage(`error.page.${pageType}.title`, [userName]) }</div>
                    <div className="boErrorPageText">{ getMessage(`error.page.${pageType}.text`, [errorStatus]) }</div>
                </div>
            </div>
        );
    };

}

export default Error


// WEBPACK FOOTER //
// ./src/app/components/error/index.js